// Shared helpers for the Download Scorecard form (used by both the
// CWPC homepage version and the Scorecard homepage version).

const REQUIRED_FIELDS = [
  ["firstName", "First Name"],
  ["lastName", "Last Name"],
  ["email", "Email"],
  ["zipCode", "Zip/Postal Code"],
  ["communityName", "Community Name"],
];

// digits, spaces and the characters used in phone formatting: + ( ) -
const PHONE_REGEX = /^[0-9+()\- ]*$/;

// Trim every text value so whitespace-only input counts as empty
export const buildDownloadPayload = (formData) => {
  const payload = {};
  Object.entries(formData).forEach(([key, value]) => {
    payload[key] = typeof value === "string" ? value.trim() : value;
  });
  return payload;
};

// Returns an error message for the first problem found, or "" when valid
export const validateDownloadForm = (payload) => {
  for (const [key, label] of REQUIRED_FIELDS) {
    if (!payload[key]) return `${label} is required.`;
  }
  if (payload.mobileNumber && !PHONE_REGEX.test(payload.mobileNumber)) {
    return "Mobile Number can only contain digits, spaces and + ( ) -";
  }
  if ((payload.referralSources || []).includes("Other") && !payload.referralOther) {
    return "Please mention where you heard about the Scorecard.";
  }
  return "";
};
